import { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useContextUsuario } from "../../contexto/usuario/UsuarioContext";
import ModoOscuro from "./ModoOscuro";

const Header = () => {
  const navigate = useNavigate();
  const { usuario, setInvernaderoSeleccionado, invernaderoSeleccionado } = useContextUsuario() || {};
  const tipoUsuario = usuario?.tipo;

  return (
    <>
      <nav className="main-header navbar navbar-expand navbar-white navbar-light" style={{ backgroundColor: "#2d9053ff" }}>
        <ul className="navbar-nav">
          <li className="nav-item">
            <a className="nav-link text-white" data-widget="pushmenu" href="#" role="button">
              <i className="fas fa-bars"></i>
            </a>
          </li>
          {tipoUsuario === "Cliente" && (
            <>
          <li className="nav-item d-none d-sm-inline-block">
                <Link to="/app/clientes/productos" className="nav-link">Productos</Link>
          </li>
          <li className="nav-item d-none d-sm-inline-block">
                <Link to="/app/clientes/servicios" className="nav-link">Servicios</Link>
          </li>
            </>
          )}
        </ul>
        <ul className="navbar-nav ml-auto">
          
          {tipoUsuario === "Cliente" && (
            <>
            </>
          )}
          {tipoUsuario === "Empleado" && invernaderoSeleccionado && (
            <li className="nav-item">
              <button
                className="nav-link btn btn-link text-white"
                onClick={() => {
                  setInvernaderoSeleccionado(null);
                  navigate("/app/admin/invernaderos/");
                }}
              >
                <i className="fas fa-sync-alt me-1"></i>
              </button>
            </li>
          )}
          {/* Botones funcionales */}
          <li className="nav-item">
            <a className="nav-link text-white" data-widget="fullscreen" href="#" role="button">
              <i className="fas fa-expand-arrows-alt"></i>
            </a>
          </li>
          <ModoOscuro/>
        </ul>
      </nav>
    </>
  );
};

export default Header;
